import {createRoot, hydrateRoot} from 'react-dom/client';
import LegalDisclaimer from '../pages/LegalDisclaimer/LegalDisclaimer'
import "../index.css";
import "../pages/LegalDisclaimer/LegalDisclaimer.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<LegalDisclaimer {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <LegalDisclaimer {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).LegalDisclaimerVC = {mount, hydrate, unmount}